import styled from 'styled-components'

export {default} from './HTMLEditor'
export type {HTMLEditorProps} from './HTMLEditor'
export type {ToolbarItem, ObvioVariable, EditorTheme} from './types'
export {defaultToolbar} from './toolbar'

/**
 * Container for HTMLEditor that adds bottom margin and ensures
 * the editor has enough space for dropdowns.
 */
export const HTMLEditorContainer = styled.div`
  margin-bottom: ${(props) => props.theme.spacing[5]};

  .html-editor .ProseMirror {
    min-height: 200px;
  }
`
